import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../constants';
import { AxiosService } from '../../services';
import { actionTypes } from '../../types';
import { getDashboardDataFailure, getDashboardDataSuccess } from '../actions/getDashboardDataActions';

function* getDashboardData({ payload, callback }) {
    try {
        const response = yield call(AxiosService, {
            method: 'get',
            base_url: base_url,
            endPoint: endpoints.getDashboardData + "?brandId=" + payload.brandId + "&platform=" + payload.platform,
            isAuth: true,
        });
        console.log('====================================');
        console.log("GET_DASHBOARD_DATA_SUCCESS status :", response.data.status);
        console.log("GET_DASHBOARD_DATA_SUCCESS data :", response.data.response);
        console.log("GET_DASHBOARD_DATA_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            getDashboardDataSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
        if (callback) {
            callback(
                response?.data?.status,
                response?.data?.response,
                response?.data?.message
            ); // Pass the response data to the callback
        }
    } catch (error) {
        console.log('====================================');
        console.log("GET_DASHBOARD_DATA_FAILURE status :", error?.response?.status);
        console.log("GET_DASHBOARD_DATA_FAILURE data:", error?.response?.data);
        console.log("GET_DASHBOARD_DATA_FAILURE error :", error);
        console.log('====================================');
        yield put(getDashboardDataFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* getDashboardDataSaga() {
    yield takeLatest(actionTypes.GET_DASHBOARD_DATA_REQUEST, getDashboardData);
}

export default getDashboardDataSaga;
